import { useState, useCallback, useMemo, RefObject } from 'react';

interface IProps {
  scrollAreaRef: RefObject<HTMLDivElement>;
  rowHeight: number;
  list: any[];
}

export const useVirtualList = ({ scrollAreaRef, rowHeight, list }: IProps) => {
  // начальные индексы для среза отображаемых офферов
  const [startIndex, setStartIndex] = useState(0);
  const [endIndex, setEndIndex] = useState(
    Math.ceil((scrollAreaRef?.current?.getBoundingClientRect().height || 0) / rowHeight),
  );

  const handleSlicedList = useCallback(() => {
    const scrollAreaHeight = scrollAreaRef?.current?.getBoundingClientRect().height || 0;
    const rowsInView = Math.ceil(scrollAreaHeight / rowHeight);
    const scrollTop = scrollAreaRef?.current?.scrollTop || 0;
    const newStartIndex = Math.max(Math.floor(scrollTop / rowHeight), 0);
    const newEndIndex = Math.min(newStartIndex + rowsInView, list.length);

    setStartIndex(newStartIndex);
    setEndIndex(newEndIndex);
  }, [list.length, scrollAreaRef, rowHeight]);

  const upperEmptyBlockHeight = useMemo(() => startIndex * rowHeight, [startIndex, rowHeight]);
  const downEmptyBlockHeight = useMemo(() => (list.length - endIndex) * rowHeight, [list, endIndex, rowHeight]);

  return { handleSlicedList, upperEmptyBlockHeight, downEmptyBlockHeight, startIndex, endIndex };
};
